export default "__VITE_ASSET__BeUttIlJ__"